module.exports = __webpack_public_path__ + "img/parameters-matching.875d0515.png";